import React from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import { selectDayFilter } from '../actions';


class HeaderFilterBs extends React.Component {
    
    render(){
        // let myFilters = [{"filter": "0-3 days"}, {"filter": "4-7 days"}, {"filter": "7+ days"}];
        // console.log(myFilters[1]);
        let allInputStyle = {};
        let pill3InputStyle = {};
        let pill7InputStyle = {};
        let pill8InputStyle = {};
        let curDayFilterText = "All Days"; //text to show on filter chosen

        if(this.props.dayFilter === "all"){
            curDayFilterText = "All Days";
        } else {
            curDayFilterText = this.props.dayFilter;
        }

        if (this.props.curDayFilter === "all"){
            allInputStyle={background:"#1C23BA", color: "#ffffff", borderColor: "#1C23BA"};
        } else {
            allInputStyle={background:"#ffffff", color: "#1C23BA", borderColor: "#1C23BA"};
        }

        if (this.props.curDayFilter === "0-3 days"){
            pill3InputStyle={background:"#1AAB2C", color: "#ffffff", borderColor: "#1AAB2C"};
        } else {
            pill3InputStyle={background:"#ffffff", color: "#1AAB2C", borderColor: "#1AAB2C"};
        }

        if (this.props.curDayFilter === "4-7 days"){
            pill7InputStyle={background:"#FFC131", color: "#ffffff", borderColor: "#FFC131"};
        } else {
            pill7InputStyle={background:"#ffffff", color: "#FFC131", borderColor: "#FFC131"};
        }

        if (this.props.curDayFilter === "7+ days"){
            pill8InputStyle={background:"#DD1A20", color: "#ffffff", borderColor: "#DD1A20"};
        } else {
            pill8InputStyle={background:"#ffffff", color: "#DD1A20", borderColor: "#DD1A20"};
        }

        return (
			<div className="card-header">
                
                    {/* For devices bigger than mobile devices */}
                    <MediaQuery minDeviceWidth={1224}>
                    <div className="card-head-row">
                    <div className="card-title">Notifications</div>
                    <div className="card-tools">
                        <ul className="nav nav-pills nav-secondary nav-sm" id="pills-tab" role="tablist">
                            <li className="nav-item submenu">
                                <a className="nav-link" id="pills-0" style={allInputStyle} data-toggle="pill" href="#pills-year" role="tab" aria-selected="true" onClick={()=> this.props.selectDayFilter("all")}>All days</a>
                            </li>
                            <li className="nav-item submenu">
                                <a className="nav-link" id="pills-3" style={pill3InputStyle} data-toggle="pill" href="#pills-today" role="tab" aria-selected="false" onClick={()=> this.props.selectDayFilter("0-3 days")}>0-3 days</a>
                            </li>
                            <li className="nav-item submenu">
                                <a className="nav-link" id="pills-7" data-toggle="pill" style={pill7InputStyle} href="#pills-week" role="tab" aria-selected="false" onClick={()=> this.props.selectDayFilter("4-7 days")}>4-7 days</a>
                            </li>
                            <li className="nav-item submenu">
                                <a className="nav-link" id="pills-8" data-toggle="pill" style={pill8InputStyle} href="#pills-month" role="tab" aria-selected="false" onClick={()=> this.props.selectDayFilter("7+ days")}>7+ days</a>
                            </li>
                        </ul>
                    </div>
                    </div>
                    </MediaQuery>
                    {/* For mobile devices */}
                    <MediaQuery maxDeviceWidth={1224}>
                    <div className="card-head-row" id="mobileFilterHeader">
                    <div className="card-title"> {this.props.systems[0].amount} Notifications</div>
                        <div className="float-right ml-3 dropdown" id="mobileDropDownArea">
                            <button className="btn btn-secondary dropdown-toggle" id="mobileDropDownButton" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                {curDayFilterText}
                            </button>
                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a className="dropdown-item" href="#" onClick={()=> this.props.selectDayFilter("all")}>All Days</a>
                                <a className="dropdown-item" href="#" onClick={()=> this.props.selectDayFilter("0-3 days")}>0-3 Days</a>
                                <a className="dropdown-item" href="#" onClick={()=> this.props.selectDayFilter("4-7 days")}>4-7 Days</a>
                                <a className="dropdown-item" href="#" onClick={()=> this.props.selectDayFilter("7+ days")}>7+ Days</a>
                            </div>
                        </div>
                        </div>
                    </MediaQuery>
            </div>
        )}
};

const mapStateToProps = (state) => {
    //console.log("Day Fileter: ", state.dayFilter);
    //console.log("HeaderFilter: ", state);
    return { curDayFilter: state.dayFilter, systems: state.systems, dayFilter: state.dayFilter };
}

export default connect(mapStateToProps, {selectDayFilter}) (HeaderFilterBs);